import React, { Component } from "react";
import {
  DataGrid,
  Column,
  Paging,
  Pager,
  FormItem,
  Selection,
} from "devextreme-react/data-grid";
import PaginaToolbar from "../../components/PaginaToolbar";
import { criarNotificacaoDiatDs } from "../../DataSources";
import UserInfo from "../../UserInfo";
import uiInfo from "../../ui-info";
import { Button } from "devextreme-react";
import Form, {
  SimpleItem,
  Label,
  GroupItem,
  ButtonItem,
  EmptyItem,
} from "devextreme-react/form";
import showReport from "../../showReport";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import axiosApi from "../../api-axios";

const localStorageKey = "cadastroNotificacaoDiatGridState";
const date = new Date();

export default class NotificacaoDiatBox extends Component {
  constructor() {
    super();
    this.state = { notificacoesIds: [] };
    this._gridInstance = React.createRef();
    this.onAtualizandoRow = this.onAtualizandoRow.bind(this);
    this.imprimirNotificacoes = this.imprimirNotificacoes.bind(this);
    this.onSelectionChanged = this.onSelectionChanged.bind(this);

    this.state = {
      filtroCorrente: [],
      filtro: {},
      notificacaoDiatDs: criarNotificacaoDiatDs(),
      popupEnviarPorLote: false,
      popupEnviarPorNumero: false,
      ano: date.getFullYear(),
      numero: undefined,
      lote: undefined,
    };
    this._gridInstance = React.createRef();
    this.filtrar = this.filtrar.bind(this);
    this.limparFiltro = this.limparFiltro.bind(this);
    this.enviarNotificacaoNumero = this.enviarNotificacaoNumero.bind(this);
    this.enviarNotificacaoLote = this.enviarNotificacaoLote.bind(this);
  }

  enviarNotificacaoNumero() {
    axiosApi
      .post(
        `notificacaodiat/enviar/${UserInfo.getPrefeitura()}/${this.state.ano}/${
          this.state.numero
        }`
      )
      .then((response) => {
        if (response.status === 200) {
          this.setState({
            notificacaoDiatDs: criarNotificacaoDiatDs(),
            popupEnviarPorNumero: false,
          });
        }
      });
  }

  enviarNotificacaoLote() {
    axiosApi
      .post(
        `notificacaodiat/enviar_lote/${UserInfo.getPrefeitura()}/${
          this.state.lote
        }`
      )
      .then((response) => {
        if (response.status === 200) {
          this.setState({
            notificacaoDiatDs: criarNotificacaoDiatDs(),
            popupEnviarPorLote: false,
          });
        }
      });
  }

  filtrar(e) {
    let filtro = this.state.filtro;

    let filtroCorrente = [];
    if (filtro.ano !== null && filtro.ano !== undefined && filtro.ano !== "") {
      filtroCorrente.push(["ano", "=", filtro.ano]);
    }
    if (
      filtro.numero !== null &&
      filtro.numero !== undefined &&
      filtro.numero !== ""
    ) {
      filtroCorrente.push(["numero", "=", filtro.numero]);
    }
    if (
      filtro.status !== null &&
      filtro.status !== undefined &&
      filtro.status !== ""
    ) {
      filtroCorrente.push(["status", "contains", filtro.status]);
    }
    if (
      filtro.lote !== null &&
      filtro.lote !== undefined &&
      filtro.lote !== ""
    ) {
      filtroCorrente.push(["lote", "contains", filtro.lote]);
    }
    if (
      filtro.tipo !== null &&
      filtro.tipo !== undefined &&
      filtro.tipo !== ""
    ) {
      filtroCorrente.push(["tipo", "contains", filtro.tipo]);
    }
    if (
      filtro.contribuinteSequencial !== null &&
      filtro.contribuinteSequencial !== undefined &&
      filtro.contribuinteSequencial !== ""
    ) {
      filtroCorrente.push([
        "contribuinte.sequencial",
        "=",
        filtro.contribuinteSequencial,
      ]);
    }
    if (
      filtro.contribuinteNome !== null &&
      filtro.contribuinteNome !== undefined &&
      filtro.contribuinteNome !== ""
    ) {
      filtroCorrente.push([
        "contribuinte.nome",
        "contains",
        filtro.contribuinteNome,
      ]);
    }
    if (
      filtro.emissao !== null &&
      filtro.emissao !== undefined &&
      filtro.emissao !== ""
    ) {
      filtroCorrente.push(["emissao", "=", filtro.emissao]);
    }
    if (
      filtro.envio !== null &&
      filtro.envio !== undefined &&
      filtro.envio !== ""
    ) {
      filtroCorrente.push(["envio", "=", filtro.envio]);
    }
    if (
      filtro.entrega !== null &&
      filtro.entrega !== undefined &&
      filtro.entrega !== ""
    ) {
      filtroCorrente.push(["entrega", "=", filtro.entrega]);
    }
    if (
      filtro.dataInicial !== null &&
      filtro.dataInicial !== undefined &&
      filtro.dataInicial !== ""
    ) {
      filtroCorrente.push(["dataLancamento", ">=", filtro.dataInicial]);
    }
    if (
      filtro.dataFinal !== null &&
      filtro.dataFinal !== undefined &&
      filtro.dataFinal !== ""
    ) {
      filtroCorrente.push(["dataLancamento", "<=", filtro.dataFinal]);
    }

    this._gridInstance.instance.filter(
      filtroCorrente.length > 0 ? filtroCorrente : null
    );
  }

  limparFiltro(e) {
    this.setState({ filtro: {} });
    this.filtrar();
  }

  onAtualizandoRow(e) {
    e.cancel = true;
    this.props.history.push("notificacaodiat/editar/" + e.data.id);
  }

  imprimirNotificacoes() {
    console.log("notificacoes ids", this.state.notificacoesIds);

    showReport("/report/notificacao/", {
      prefeituraId: UserInfo.getPrefeitura(),
      notificacoesIds: this.state.notificacoesIds,
    });
  }

  onSelectionChanged({ selectedRowKeys }) {
    this.setState({ notificacoesIds: selectedRowKeys });
  }

  render() {
    const statusOptions = [
      { id: "0", descricao: "1 - Gerada" },
      { id: "1", descricao: "2 - Enviada" },
      { id: "2", descricao: "3 - Entregue" },
      { id: "3", descricao: "4 - Não Encontrado" },
      { id: "4", descricao: "5 - Recusado" },
    ];

    const escolherStatus = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      dataSource: statusOptions,
      valueExpr: "id",
      displayExpr: "descricao",
    };

    return (
      <div className={"content-block dx-card responsive-paddings"}>
        <div
          style={{
            display: "flex",
            marginTop: "25px",
          }}
        >
          <div style={{ display: "inline-block", justifyContent: "left"}}>
            <Button
              width={200}
              text="Imprimir Notificações"
              type="success"
              onClick={this.imprimirNotificacoes}
              alignment={"left"}
            />
          </div>
          <div style={{ display: "inline-block", marginLeft:"550px", justifyContent: "right"}}>
            <Button
              width={250}
              text="Enviar Notificação por Lote"
              type="success"
              onClick={() => this.setState({ popupEnviarPorLote: true })}
              alignment={"left"}
            />
          </div>
          <div style={{ display: "inline-block", marginLeft:"20px", justifyContent: "right"}}>
            <Button
              width={250}
              text="Enviar Notificação por Número"
              type="success"
              onClick={() => this.setState({ popupEnviarPorLote: true })}
              alignment={"left"}
            />
          </div>
        </div>

        <br />
        <br />
        <form onSubmit={this.filtrar}>
          <Form
            id="frmPesquisa"
            formData={this.state.filtro}
            colCount={1}
            labelLocation={"top"}
          >
            <GroupItem caption="Filtros" colCount={5}>
              <SimpleItem
                dataField="ano"
                editorType={"dxNumberBox"}
                colSpan={1}
                editorOptions={{ value: null, step: 0 }}
              >
                <Label text="Ano" />
              </SimpleItem>
              <SimpleItem
                dataField="numero"
                editorType={"dxNumberBox"}
                colSpan={1}
                editorOptions={{ value: null, step: 0 }}
              >
                <Label text="Número" />
              </SimpleItem>
              <SimpleItem dataField="status" colSpan={1}>
                <Label text="Estado" />
              </SimpleItem>
              <SimpleItem dataField="lote" colSpan={1}>
                <Label text="Lote" />
              </SimpleItem>
              <SimpleItem dataField="tipo" colSpan={1}>
                <Label text="Tipo" />
              </SimpleItem>
              <SimpleItem
                dataField="contribuinteSequencial"
                editorType={"dxNumberBox"}
                colSpan={1}
                editorOptions={{ value: null, step: 0 }}
              >
                <Label text="Código do Contribuinte" />
              </SimpleItem>
              <SimpleItem dataField="contribuinteNome" colSpan={4}>
                <Label text="Nome do Contribuinte" />
              </SimpleItem>
              <SimpleItem
                dataField="emissao"
                editorType="dxDateBox"
                colSpan={1}
                editorOptions={{ width: "100%" }}
              >
                <Label text="Data de Emissão" />
              </SimpleItem>
              <SimpleItem
                dataField="envio"
                editorType="dxDateBox"
                colSpan={1}
                editorOptions={{ width: "100%" }}
              >
                <Label text="Data de Envio" />
              </SimpleItem>
              <SimpleItem
                dataField="entrega"
                editorType="dxDateBox"
                colSpan={1}
                editorOptions={{ width: "100%" }}
              >
                <Label text="Data de Entrega" />
              </SimpleItem>
              <SimpleItem
                dataField="dataInicial"
                editorType="dxDateBox"
                colSpan={1}
                editorOptions={{ width: "100%" }}
              >
                <Label text="Data Inicial" />
              </SimpleItem>
              <SimpleItem
                dataField="dataFinal"
                editorType="dxDateBox"
                colSpan={1}
                editorOptions={{ width: "100%" }}
              >
                <Label text="Data Final" />
              </SimpleItem>
            </GroupItem>
          </Form>
          <br />
          <div
            style={{
              marginTop: "10px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <div style={{ display: "inline-block" }}>
              <Button
                width={120}
                text="Filtrar"
                type="success"
                onClick={this.filtrar}
              />
            </div>
            <div style={{ display: "inline-block", marginLeft: "10px" }}>
              <Button text="Limpar Filtro" onClick={this.limparFiltro} />
            </div>
          </div>
        </form>
        <br />
        <br />
        <PaginaToolbar
          titulo="Lista de Notificações"
          novoCb={this.novaNotificacaoDiat.bind(this)}
        >
          <DataGrid
            ref={(grid) => (this._gridInstance = grid)}
            dataSource={this.state.notificacaoDiatDs}
            showBorders={true}
            rowAlternationEnabled={true}
            remoteOperations={true}
            columnAutoWidth={true}
            columnHidingEnabled={true}
            focusedRowEnabled={true}
            wordWrapEnabled={window.innerWidth < 800}
            filterSyncEnabled={true}
            onEditingStart={this.onAtualizandoRow}
            onSelectionChanged={this.onSelectionChanged}
          >
            <Selection
              mode="multiple"
              selectAllMode={"allPages"}
              showCheckBoxesMode={"always"}
            />
            <Column
              type="buttons"
              fixed={true}
              fixedPosition={"left"}
              caption="Protocolo"
              buttons={[
                {
                  text: "Protocolo de Entrega",
                  icon: "exportpdf",
                  onClick: (e) =>
                    this.props.history.push({
                      pathname: "/protocolo_entrega_notificacao",
                      data: e.row.data,
                    }),
                },
              ]}
            />
            <Column
              dataField={"id"}
              caption={"ID"}
              alignment={"center"}
              visible={false} 
              sortOrder="desc"
              allowSorting={true}
            />
            <Column
              dataField={"prefeituraId"}
              caption={"Prefeitura"}
              visible={false}
            >
              <FormItem visible={false}></FormItem>
            </Column>
            <Column dataField={"numeroStr"} caption={"Número"} width={100} allowSorting={false} />
            <Column dataField={"statusStr"} caption={"Situação"} width={120} />
            <Column
              dataField={"emissao"}
              dataType={"date"}
              caption={"Dt. Emissão"}
              width={120}
            />
            <Column dataField={"lote"} caption={"Lote"} width={100} />
            <Column dataField={"contribuinte.sequencial"} caption={"IMC"} width={120}/>
            <Column dataField={"contribuinte.nome"} caption={"Contribuinte"} />
            <Column dataField={"contribuinte.cpfCnpjFormatado"} caption={"CPF/CNPJ"} width={150}/>
            <Column dataField={"enviadoEm"} caption={"Data de Envio"} width={120} />
            <Column dataField={"entregueEm"} caption={"Data de Entrega"} width={140}/>
            <Column dataField={"tipo.tipo"} caption={"Tipo"} />
            <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
            <Pager
              showPageSizeSelector={true}
              allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
            />
          </DataGrid>
        </PaginaToolbar>
        <Popup
          visible={this.state.popupEnviarPorLote}
          onHiding={() => this.setState({ popupEnviarPorLote: false })}
          dragEnabled={false}
          closeOnOutsideClick={false}
          showCloseButton={false}
          showTitle={true}
          width={"15%"}
          height={"20%"}
          title="Enviar Notificação por Lote"
        >
          <div style={{ marginTop: "25px" }}>
            <Form colCount={6} formData={this.state} labelLocation={"top"}>
              <EmptyItem colSpan={2} />
              <SimpleItem dataField="lote" colSpan={2}>
                <Label text="Lote" />
              </SimpleItem>
            </Form>
          </div>
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Enviar Lote",
              type: "success",
              width: 150,
              onClick: this.enviarNotificacaoLote,
            }}
          ></ToolbarItem>
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Fechar",
              type: "default",
              width: 150,
              onClick: () => this.setState({ popupEnviarPorLote: false }),
            }}
          ></ToolbarItem>
        </Popup>
        <Popup
          visible={this.state.popupEnviarPorNumero}
          onHiding={() => this.setState({ popupEnviarPorNumero: false })}
          dragEnabled={false}
          closeOnOutsideClick={false}
          showCloseButton={false}
          showTitle={true}
          width={"15%"}
          height={"20%"}
          title="Enviar Notificação por Número"
        >
          <div style={{ marginTop: "25px" }}>
            <Form colCount={6} formData={this.state} labelLocation={"top"}>
              <EmptyItem colSpan={1} />
              <SimpleItem dataField="ano" colSpan={2}>
                <Label text="Ano" />
              </SimpleItem>
              <SimpleItem dataField="numeroNotificacao" colSpan={2}>
                <Label text="Número" />
              </SimpleItem>
            </Form>
          </div>
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Enviar Notificação",
              type: "success",
              width: 150,
              onClick: this.enviarNotificacaoNumero,
            }}
          ></ToolbarItem>
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Fechar",
              type: "default",
              width: 150,
              onClick: () => this.setState({ popupEnviarPorNumero: false }),
            }}
          ></ToolbarItem>
        </Popup>
      </div>
    );
  }

  novaNotificacaoDiat() {
    let gridState = this._gridInstance.instance.state();
    localStorage.setItem(localStorageKey, JSON.stringify(gridState));
    this.props.history.push("notificacaodiat/novo");
  }
}
